import React, { FunctionComponent } from 'react'
import clsx from 'clsx'
import { KINDS, SHAPE_TYPES } from './constants'
import styles from './style.module.scss'
import { useThemeClass } from '../Theme'

type KindsType = typeof KINDS
type KindsKeys = keyof KindsType

type ShapeTypes = typeof SHAPE_TYPES
type ShapeKeys = keyof ShapeTypes

type CSSClasses = keyof typeof styles

export type SkeletonKinds = KindsType[KindsKeys]
export type SkeletonShapes = ShapeTypes[ShapeKeys]

export interface SkeletonProps {
  testNameSpace?: string
  kind?: SkeletonKinds
  shape?: SkeletonShapes
}

export const Skeleton: FunctionComponent<SkeletonProps> = ({ testNameSpace = '', kind = KINDS.DEFAULT, shape = SHAPE_TYPES.DEFAULT }) => {
  const themeClass = useThemeClass()
  const skeletonClassNames = clsx(
    styles.skeleton,
    styles[`skeleton${kind}` as CSSClasses],
    styles[`skeletonShape${shape}` as CSSClasses],
    styles[`${themeClass}`]
  )
  return <div className={skeletonClassNames} {...(testNameSpace.length > 0 && { 'data-testid': testNameSpace })} />
}

Skeleton.displayName = 'Skeleton'
